import classNames from "classnames";

import type {ButtonType} from "../Button";
import {IconSize} from "../icons";


import {LoadingIcon} from "../icons/LoadingIcon";


import './LoadingCircle.css';


export type LoadingIconProps = {
    className?: string;
    type?: ButtonType;
    size?: IconSize;
}


export const LoadingCircle = (
    {
        className,
        type = 'primary',
        size = 48,
    }: LoadingIconProps
) => {

    return (
        <div className={classNames({
            "LoadingCircle": true,
            [className!]: className,
        })}>
            <LoadingIcon
                type={type}
                size={size}
            />
        </div>
    )
}
